var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicMouse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M383.5,135.9h8.4C391.9,60.5,331.4,0,256,0S120.1,60.5,120.1,135.9v240.2c0,75.4,60.5,135.9,135.9,135.9 s135.9-60.5,135.9-135.9V135.9H383.5h-8.4v240.2c0,33.5-13,63.3-35.4,84.7c-21.4,21.4-52.1,35.4-84.7,35.4 c-33.5,0-63.3-13-84.7-35.4c-21.4-21.4-35.4-52.1-35.4-84.7V135.9c0-33.5,13-63.3,35.4-84.7c21.4-21.4,52.1-35.4,84.7-35.4 c33.5,0,63.3,13,84.7,35.4c21.4,21.4,35.4,52.1,35.4,84.7H383.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_4_",
    points: "246.7,80.1 246.7,144.3 263.4,144.3 263.4,80.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicMouse1);
export default __webpack_public_path__ + "static/media/magic-mouse_1.d77484244ee0b5e4db6fa98a2db9543c.svg";
export { ForwardRef as ReactComponent };